<div class="thm-page-content">
    <h2 class="thm-page-title aof-menu-header ng-star-inserted" (click)="toggleMenu()">
        <span class="d-none d-lg-block mr-2">
            {{ 'menu.menuSuffix' | transloco }}{{ menuTitle | transloco }}
        </span>
        <i class="fas d-lg-none" [class.fa-bars]="!isMenuOpen" [class.fa-times]="isMenuOpen"></i>
    </h2>

    <div class="aof-menu" [class.mobile-open]="isMenuOpen">

        <!-- Mobil Menü Başlığı (Sadece mobilde görünür) -->
        <div class="d-lg-none mobile-menu-header">
            <span class="mobile-menu-title">{{ 'menu.menuSuffix' | transloco }}{{ menuTitle | transloco }}</span>
        </div>

        <!-- Ana Navigasyon -->
        <nav class="aof-menu__nav">
            <ng-container *ngFor="let item of items">
                <ng-container *ngIf="!item.menuTitle">
                    <a [routerLink]="item.link" routerLinkActive="is-active"
                        [routerLinkActiveOptions]="item.exact ? {exact: true} : {exact: false}" class="aof-menu__item">

                        <span class="aof-menu__item-icon">
                            <i [class]="item.icon"></i>
                        </span>

                        <span class="aof-menu__item-label">{{ item.label | transloco }}</span>

                        <i class="fas fa-chevron-right aof-menu__item-arrow"></i>
                    </a>
                </ng-container>
            </ng-container>
        </nav>

        <!-- Ayırıcı Çizgi -->
        <hr *ngIf="hasNavItems" class="aof-menu__divider">

        <!-- Alt Bölüm: Profil + Anasayfa -->
        <div class="aof-menu__footer" [class.aof-menu__footer--no-nav]="!hasNavItems">

            <!-- Profilim -->
            <a [routerLink]="['/aday/profil/nufus']" [queryParams]="profilParams" class="aof-menu__item"
                routerLinkActive="is-active">
                <span class="aof-menu__item-icon">
                    <i class="fas fa-user-cog"></i>
                </span>
                <span class="aof-menu__item-label">{{ 'menu.profilim' | transloco }}</span>
                <i class="fas fa-chevron-right aof-menu__item-arrow"></i>
            </a>

            <!-- Geri Dön (Varsa) -->
            <a *ngIf="backLink" [routerLink]="backLink.url" class="aof-menu__item aof-menu__item--back">
                <span class="aof-menu__item-icon">
                    <i class="fas fa-arrow-left"></i>
                </span>
                <span class="aof-menu__item-label">
                    {{ 'menu.geriDon' | transloco: { target: (backLink.label | transloco) } }}
                </span>
            </a>

            <!-- Anasayfa -->
            <a [routerLink]="['/']" class="aof-menu__item aof-menu__item--back">
                <span class="aof-menu__item-icon">
                    <i class="fas fa-arrow-left"></i>
                </span>
                <span class="aof-menu__item-label">{{ 'menu.anasayfa' | transloco }}</span>
            </a>

        </div>

    </div>
</div>